const whitelist = [
    '8b90f55d-a507-4941-ae84-e33318fcc61f',
    '887e8eed-8f6a-4323-8562-881893041146', // prod mai.
    '797edffd-d20c-4482-baaf-8e346d41bc9e', //staging mai.
];
const is_contact_feature_enabled_for_user = (userId: string): boolean => {
    const condition = whitelist.includes(userId);
    return condition;
};

export default is_contact_feature_enabled_for_user;
